const project_data = [
  {
    name: 'projects',
    icon: 'plant',
    key: 'projects'
  },
  {
    name: 'donors',
    icon: 'group-2',
    key: 'participants'
  },
]
const main_pre_activity_data = [
  {
    name: 'scooping_visits',
    icon: 'focus-3-line',
    key: 'scooping-visits'
  },
]
const pre_activity_data = [
  {
    name: 'scooping_visits',
    icon: 'focus-3-line',
    key: 'scooping-visits'
  },
  {
    name: 'rras',
    icon: 'crosshair-line',
    key: 'rras'
  },
  {
    name: 'pras',
    icon: 'crosshair-2-line',
    key: 'pras'
  },
  {
    name: 'program_socializations',
    icon: 'projector-line',
    key: 'program-socializations'
  },
  {
    name: 'organization_groups',
    icon: 'user-community-line',
    key: 'organization-groups'
  },
]
const mangrove_pre_activity_data = [
  {
    name: 'mangrove_rras',
    icon: 'crosshair-line',
    key: 'mangrove-rras'
  },
  {
    name: 'mangrove_pras',
    icon: 'crosshair-2-line',
    key: 'mangrove-pras'
  },
  {
    name: 'mangrove_program_socializations',
    icon: 'projector-line',
    key: 'mangrove-program-socializations'
  },
  // {
  //   name: 'mangrove_farmer_groups',
  //   icon: 'user-community-line',
  //   key: 'mangrove-farmer-groups'
  // },
]
const main_data = [
  {
    name: 'grower',
    icon: 'body-scan',
    key: 'farmers'
  },
  {
    name: 'lahans',
    icon: 'collage-line',
    key: 'lahans'
  },
]
const activity_data = [
  {
    name: 'planting_socializations',
    icon: 'projector-2-line',
  },
  {
    name: 'planting_holes',
    icon: 'flower-line',
  },
]

const module = {
  config: {
    name: "grower-activity",
    icon: "dashboard",
    desc: "Data Utama untuk pengelolaan Project pada Aplikasi",
    layout: true,
    order: 1
  },
  routes: [
    {
      name: 'data-project',
      type: 'parent',
      // icon: "user",
      redirectName: 'projects',
      child: [
        ...project_data.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.key,
            component: () => import(`./${v.key}/${v.key}.vue`),
            separator: null
          }
        }),
      ]
    },
    // {
    //   name: 'main-pre-planting-activity',
    //   type: 'parent',
    //   // icon: "user",
    //   redirectName: 'scooping_visits',
    //   child: [
    //     ...main-pre_activity_data.flatMap(v => {
    //       return {
    //         name: v.name,
    //         icon: v.icon,
    //         path: `/${v.name}`,
    //         translate_key: v.name,
    //         component: () => import(`./main-pre-planting-activity/${v.key}/${v.key}.vue`),
    //         separator: null
    //       }
    //     }),
    //   ]
    // },
    {
      name: 'pre-planting-activity',
      type: 'parent',
      // icon: "user",
      redirectName: 'scooping_visits',
      child: [
        ...pre_activity_data.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./pre-planting-activity/${v.key}/${v.key}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'mangrove-pre-planting-activity',
      type: 'parent',
      // icon: "user",
      redirectName: 'program_socializations',
      child: [
        ...mangrove_pre_activity_data.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./mangrove-pre-planting-activity/${v.key}/${v.key}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'data-utama',
      type: 'parent',
      // icon: "user",
      redirectName: 'grower',
      child: [
        ...main_data.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: () => import(`./${v.key}/${v.key}.vue`),
            separator: null
          }
        }),
      ]
    },
    {
      name: 'activity',
      type: 'parent',
      // icon: "user",
      redirectName: 'planting_socialization',
      child: [
        ...activity_data.flatMap(v => {
          return {
            name: v.name,
            icon: v.icon,
            path: `/${v.name}`,
            translate_key: v.name,
            component: "",
            separator: null
          }
        }),
      ]
    },
    // // farmers
    // {
    //   name: 'grower',
    //   icon: 'body-scan',
    //   path: '/grower',
    //   translate_key: 'grower',
    //   component: () => import('./farmers/farmers.vue'),
    //   separator: ""
    // },
    // // lahans
    // {
    //   name: 'lahans',
    //   icon: 'collage-line',
    //   path: '/lahans',
    //   translate_key: 'lahans',
    //   component: () => import('./lahans/lahans.vue'),
    //   separator: ""
    // },
    // // projects
    // {
    //   name: 'projects',
    //   icon: 'plant',
    //   path: '/projects',
    //   translate_key: 'projects',
    //   component: () => import('./projects/projects.vue'),
    //   separator: ""
    // },
    // // donors
    // {
    //   name: 'donors',
    //   icon: 'group-2',
    //   path: '/donors',
    //   translate_key: 'participants',
    //   component: () => import('./participants/participants.vue'),
    //   separator: ""
    // },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/main-data/_index.js